'use client';

import dynamic from 'next/dynamic';

export const ScrapingHeroCard = dynamic(() =>
  import('./ScrapingHeroCard').then((m) => m.ScrapingHeroCard)
);
